import comp from "./SubjectGroupSelect";
export default comp;
